import { useMemo, useRef, useState, useEffect } from "react";

import { Skeleton } from "@/components";
import { cn } from "@/utils";

const Circle = () => (
  <div className="h-[48px] w-[48px] shrink-0 rounded-full bg-surface-thumbnail" />
);

const Line = ({ className }: { className: string }) => (
  <div className={cn("h-4 rounded-[16px] bg-surface-thumbnail", className)} />
);

const SkeletonSection = () => (
  <Skeleton className="flex w-full gap-4 bg-transparent pr-4">
    <Circle />
    <div className="flex h-full w-full flex-col justify-center gap-2">
      <Line className="w-[45%]" />
      <Line className="w-full" />
    </div>
  </Skeleton>
);

export const CommunityFeedSkeleton = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [numberOfSkeletons, setNumberOfSkeletons] = useState(0);

  useEffect(() => {
    const updateSkeletons = () => {
      if (containerRef.current?.clientHeight) {
        setNumberOfSkeletons(
          Math.floor(containerRef.current.clientHeight / 96 + 1),
        );
      }
    };

    updateSkeletons();
    window.addEventListener("resize", updateSkeletons);
    return () => window.removeEventListener("resize", updateSkeletons);
  }, []);

  const skeletons = useMemo(() => {
    return Array.from({ length: numberOfSkeletons }, (_, index) => (
      <SkeletonSection key={index} />
    ));
  }, [numberOfSkeletons]);

  return (
    <div ref={containerRef} className="flex h-full w-full justify-center pl-3">
      <div className="flex w-full flex-col gap-[48px]">{skeletons}</div>
    </div>
  );
};
